// @ is an alias to /src
import Setting from "../../setting.js";
import PageHeader from "@/components/PageHeaderHome.vue";
import Venues from "@/components/Venues.vue";
import Separator from "@/components/Separator.vue";
import Participants from "@/components/Participants.vue";
import Footer from "@/components/Footer.vue";

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";

SwiperCore.use([Navigation, Pagination]);

export default {
  name: "Home2025",
  components: {
    PageHeader,
    Venues,
    Separator,
    Participants,
    Footer,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      venues: null,
      alphabet: null,
      slideDetailShow: false,
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Scrollbar, A11y], // Pagination           :pagination="{ clickable: true }"
    };
  },
  created() {
    this.axios
      .get(Setting[process.env.NODE_ENV].API + "Venue/GetAll", {
        params: {
          year: 2025,
        },
      })
      .then((response) => {
        if (this.$route.params.season == "SPRING") {
          this.venues = response.data.filter(
            (x) =>
              x.id == 49 ||
              x.id == 50 ||
              x.id == 51 ||
              x.id == 52 ||
              x.id == 53 ||
              x.id == 54 ||
              x.id == 55 ||
              x.id == 56
          );
        } else if (this.$route.params.season == "FALL") {
          this.venues = response.data.filter(
            (x) =>
              x.id == 57 || x.id == 58 || x.id == 59 || x.id == 60 || x.id == 61
          );
        }
      });

    this.axios
      .get(Setting[process.env.NODE_ENV].API + "Venue/GetBands", {
        params: {
          year: 2025,
        },
      })
      .then((response) => {
        this.alphabet = response.data;
      });
  },
  methods: {
    onShowHideSlideDetail() {
      if (!this.slideDetailShow) {
        this.slideDetailShow = true;
      } else {
        this.slideDetailShow = false;
      }
    },
    onClick() {
      this.slideDetailShow = false;
    },
  },
};
